import React, { useState, useEffect, useCallback } from "react";
import { useSelector } from "react-redux";
import "./Plagiarism_1.css";
import { Link } from "react-router-dom";
import {
  Button,
  Card,
  CardContent,
  Typography,
  IconButton,
  Tooltip,
  Box,
  Paper,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  LinearProgress,
  Fade,
  Grow,
  Divider,
  Breadcrumbs,
} from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import DownloadIcon from "@mui/icons-material/Download";
import { Delete } from "@mui/icons-material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import HistoryIcon from "@mui/icons-material/History";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import SpellcheckIcon from "@mui/icons-material/Spellcheck";
import TimerIcon from "@mui/icons-material/Timer";
import ArticleIcon from "@mui/icons-material/Article";
import FormatQuoteIcon from "@mui/icons-material/FormatQuote";
import CloseIcon from "@mui/icons-material/Close";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import HomeIcon from "@mui/icons-material/Home";
import WarningIcon from "@mui/icons-material/Warning";
import {
  ContentState,
  Editor,
  EditorState,
  Modifier,
  RichUtils,
  SelectionState,
  convertToRaw,
  CompositeDecorator,
} from "draft-js";
import {
  checkPlagiarism,
  getPlagiarismDetails,
  getUniqueSentence,
} from "../../services/plagiarismServices";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import Loader from "../../utils/loader";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SuggestionCard from "./SuggestionCard";
import DataGridMui from "../ReusableComponents/DataGridMui";
import "draft-js/dist/Draft.css";
import { useHistory } from "react-router-dom";
import ScanPlagarismservice from "../../services/ScanPlagarismservice";
import { addUserLogs } from "../../services/userLogServices";
import { useCheckFeatureAccess } from "../CheckFeature";
import SubscriptionRequired from "../SubscriptionRequired";
import { useCheckSubscriptionPlanAccess } from "../SubscriptionAccess";
import { checkAIRequestLimit } from "../aiRequestLimit";
import { AutoFixHigh } from "@mui/icons-material";

const findWithRegex = (regex, contentBlock, callback) => {
  const text = contentBlock.getText();
  let match;
  while ((match = regex.exec(text)) !== null) {
    callback(match.index, match.index + match[0].length);
  }
};

const createDecorator = (outputArray) => {
  return new CompositeDecorator(
    outputArray.map((item) => ({
      strategy: (contentBlock, callback, contentState) => {
        const regex = new RegExp(
          item.sentenceDetails.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"),
          "g",
        );
        findWithRegex(regex, contentBlock, callback);
      },
      component: (props) => (
        <span style={{ backgroundColor: "#ff4242" }} data-url={item.url}>
          {props.children}
        </span>
      ),
    })),
  );
};

const highlightText = (editorState, outputArray) => {
  const decorator = createDecorator(outputArray);
  return EditorState.set(editorState, { decorator });
};

const Plagiarism_1 = ({ userId }) => {
  const userDetails = useSelector((user) => user);
  const userID = userId ? userId : userDetails.user.currentUser._id;
  const [editorState, setEditorState] = useState(() =>
    EditorState.createEmpty(),
  );
  const [sentenceCount, setSentenceCount] = useState(0);
  const [paraCount, setParaCount] = useState(0);
  const [uniqueWordCount, setUniqueWordCount] = useState(0);
  const [uniqueWordPercent, setUniqueWordPercent] = useState();
  const [speakTime, setSpeakTime] = useState(0);
  const [plagiarozedProgress, setPlagiarozedProgress] = useState(0);
  const [uniqueProgress, setUniqueProgress] = useState(0);
  const [loading, setLoading] = useState(false);
  const [sourceCount, setSourceCount] = useState(0);
  const [outputArray, setOutputArray] = useState([]);
  const [selectedSentence, setSelectedSentence] = useState("");
  const [isUniqueButton, setIsUniqueButton] = useState(false);
  const [wordsCount, setWordsCount] = useState(0);
  const [timeDisplay, setTimeDisplay] = useState("0 sec");
  const [scanHistory, setScanHistory] = useState([]);
  const [P_File, setP_File] = useState("File");
  const [inputKey, setInputKey] = useState(0);
  const [historyDialogOpen, setHistoryDialogOpen] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  
  // State for word limit warning dialog
  const [wordLimitDialogOpen, setWordLimitDialogOpen] = useState(false);
  const [wordLimitExceeded, setWordLimitExceeded] = useState(false);
  
  const accessToDelete = useCheckFeatureAccess("plagiarism", "delete");
  const accessToPlagiarism = useCheckFeatureAccess("plagiarism", "plagiarism");
  const accessToUpload = useCheckFeatureAccess("plagiarism", "upload");
  const accessToPlagiarismScreen = useCheckSubscriptionPlanAccess("Plagiarism");
  const [subReqOpen, setSubReqOpen] = useState(false);
  const [isFeatureInside, setIsFeatureInside] = useState(false);
  const accessToScanHistory = useCheckSubscriptionPlanAccess("scanHistory");

  // fullscreen layout
  useEffect(() => {
    document.body.style.margin = "0";
    document.body.style.padding = "0";
    return () => {};
  }, []);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (accessToPlagiarismScreen == false) {
      setSubReqOpen(true);
    }
  }, [accessToPlagiarismScreen]);

  const history = useHistory();
  let maxWords = 1500;

  // Function to reset plagiarism states
  const resetPlagiarismStates = useCallback(() => {
    setSourceCount(0);
    setPlagiarozedProgress(0);
    setUniqueProgress(0);
    setOutputArray([]);
    setIsUniqueButton(false);
  }, []);

  // Function to calculate word count from text
  const getWordCount = useCallback((text) => {
    if (!text || text.trim() === "") return 0;
    return text.trim().split(/\s+/).length;
  }, []);

  // Function to calculate text statistics
  const calculateTextStats = useCallback((text) => {
    if (!text || text.trim() === "") {
      setParaCount(0);
      setSentenceCount(0);
      setUniqueWordCount(0);
      setTimeDisplay("0 sec");
      setWordsCount(0);
      return {
        paragraph: 0,
        sentence: 0,
        uniqueWords: 0,
        speakingTime: "0 sec",
        wordCount: 0,
      };
    }

    // Calculate paragraphs
    const paragraphs = text
      .split("\n")
      .filter((line) => line.trim() !== "").length;

    // Calculate sentences
    const sentences = text
      .split(/[.!?]/)
      .filter((sentence) => sentence.trim() !== "").length;

    // Calculate unique words
    const words = text
      .toLowerCase()
      .split(/\W+/)
      .filter((word) => word.trim() !== "");
    const uniqueWords = [...new Set(words)].length;

    // Calculate word count
    const wordCount = words.length;

    // Calculate speaking time
    const wordsPerMinute = 150;
    const speakingTimeMinutes = wordCount / wordsPerMinute;
    const minutes = Math.floor(speakingTimeMinutes);
    const seconds = Math.round((speakingTimeMinutes % 1) * 60);

    let finalTime = "";
    if (speakingTimeMinutes < 1) {
      finalTime = `${seconds} sec`;
    } else {
      finalTime = `${minutes} min ${seconds} sec`;
    }

    // Update state
    setParaCount(paragraphs);
    setSentenceCount(sentences);
    setUniqueWordCount(uniqueWords);
    setTimeDisplay(finalTime);
    setWordsCount(wordCount);

    return {
      paragraph: paragraphs,
      sentence: sentences,
      uniqueWords: uniqueWords,
      speakingTime: finalTime,
      wordCount: wordCount,
    };
  }, []);

  const calculateSpeakTime = (countstats, isTable = false) => {
    const contentState = editorState.getCurrentContent();
    const rawText = convertToRaw(contentState);
    const text = rawText.blocks.map((block) => block.text).join(" ");
    if (text == "") {
      setTimeDisplay(`0 sec`);
    }
    const wordsPerMinute = 150;
    const wordCount = text.split(/\s+/).length;
    const speakingTimeMinutes = wordCount / wordsPerMinute;
    const minutes = Math.floor(speakingTimeMinutes);
    const seconds = Math.round((speakingTimeMinutes % 1) * 60);
    let finalTime = "";
    if (speakingTimeMinutes < 1) {
      setTimeDisplay(`${seconds} sec`);
      finalTime = `${seconds} sec`;
    } else {
      setTimeDisplay(`${minutes} min ${seconds} sec`);
      finalTime = `${minutes} min ${seconds} sec`;
    }
    if (!isTable) {
      addScanHistory(countstats, finalTime);
    }
  };

  const handleDeleteClick = async (id) => {
    const toastId = showConfirmationToast(
      "Are you sure you want to delete this scan history?",
      () => deleteHistory(id),
      () => toast.dismiss(toastId),
    );
  };

  const showConfirmationToast = (message, onConfirm, onCancel) => {
    const toastId = toast.info(
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <div style={{ marginBottom: "10px" }}>
          <h4>Delete Scan History</h4>
        </div>
        <p style={{ marginBottom: "10px" }}>{message}</p>
        <div style={{ display: "flex", gap: "10px" }}>
          <button
            onClick={() => {
              onConfirm();
              toast.dismiss(toastId);
            }}
            style={{
              padding: "8px 12px",
              backgroundColor: "white",
              color: "#1976D2",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          >
            Yes
          </button>
          <button
            onClick={() => {
              onCancel();
              toast.dismiss(toastId);
            }}
            style={{
              padding: "8px 12px",
              backgroundColor: "white",
              color: "#1976D2",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          >
            No
          </button>
        </div>
      </div>,
      {
        position: toast.POSITION.TOP_CENTER,
        autoClose: false,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
      },
    );
    return toastId;
  };

  const handleChange = (newEditorState) => {
    setEditorState(newEditorState);

    const text = newEditorState.getCurrentContent().getPlainText();

    // Calculate and update text statistics in real-time
    calculateTextStats(text);

    // Reset plagiarism states if text becomes empty
    if (text.trim() === "") {
      resetPlagiarismStates();
    }

    const selectionState = newEditorState.getSelection();
    if (!selectionState.isCollapsed()) {
      const anchorKey = selectionState.getAnchorKey();
      const currentContent = newEditorState.getCurrentContent();
      const currentContentBlock = currentContent.getBlockForKey(anchorKey);
      const start = selectionState.getStartOffset();
      const end = selectionState.getEndOffset();
      const selectedText = currentContentBlock.getText().slice(start, end);
      setSelectedSentence(selectedText);
      if (sourceCount !== 0) {
        setIsUniqueButton(true);
      }
    }
  };

  const checkPlagiarismSentence = async (outputSentence = "", isTable) => {
    let sentence;
    const selection = editorState.getSelection();
    sentence = editorState
      .getCurrentContent()
      .getBlockForKey(selection.getAnchorKey())
      .getText()
      .slice(selection.getStartOffset(), selection.getEndOffset());
    if (!sentence) {
      sentence = editorState.getCurrentContent().getPlainText();
    }
    setLoading(true);

    // Reset plagiarism states before new check
    resetPlagiarismStates();

    const text = editorState.getCurrentContent().getPlainText();
    const stats = calculateTextStats(text);

    let data = {
      text: outputSentence !== "" ? outputSentence : sentence,
    };
    let userId = sessionStorage.getItem("userId");
    let isCoAuthor = false;
    let plagiarismResponse = await checkPlagiarism(data, userId, isCoAuthor);
    if (plagiarismResponse.status == 400) {
      setLoading(false);
      toast.warn(plagiarismResponse.message);
      return;
    }
    if (plagiarismResponse?.data?.details?.plagPercent !== 0) {
      const data = {
        userId: sessionStorage.getItem("userId"),
        organizationId: sessionStorage.getItem("organizationId"),
        actionType: "plagiarism",
      };
      const addLogs = await addUserLogs(data);
      if (addLogs.status !== 200) {
        toast.error(addLogs.message);
      }
      setUniqueProgress(plagiarismResponse.data.uniquePercent);
      setPlagiarozedProgress(plagiarismResponse.data.plagPercent);
      let plagDetails = plagiarismResponse.data.details;
      let sourceDetails = plagiarismResponse.data.sources;
      let sentenceArray = [];
      let filterPlagDetails = plagDetails.filter((item) => !item.unique);
      setSourceCount(sourceDetails.length);
      filterPlagDetails.map((obj) => {
        let outObject = {
          sentenceDetails: obj.query,
          url: obj?.display?.url,
        };
        sentenceArray.push(outObject);
      });
      setOutputArray(sentenceArray);
      setLoading(false);

      // Add scan history after plagiarism check
      if (!isTable) {
        addScanHistory(stats, stats.speakingTime);
      }
    } else {
      // If no plagiarism found, set progress to 100% unique
      setUniqueProgress(100);
      setPlagiarozedProgress(0);
      setLoading(false);

      // Add scan history even if no plagiarism found
      if (!isTable) {
        addScanHistory(stats, stats.speakingTime);
      }
    }
  };

  // Updated handleCheckPlagiarism with word limit check
  const handleCheckPlagiarism = async () => {
    // const checkailimit = await checkAIRequestLimit(userID);
    // if (checkailimit == false) {
    //   toast.warn("AI request limit reached.");
    //   return;
    // }
    const text = editorState.getCurrentContent().getPlainText();
    const wordCount = getWordCount(text);
    
    if (text == "") {
      toast.warn(`You don't have text to check for plagiarism`);
      return;
    } else if (wordCount > maxWords) {
      setWordLimitDialogOpen(true);
      setWordLimitExceeded(true);
      return;
    }
    checkPlagiarismSentence();
  };

  // Handle word limit dialog close
  const handleWordLimitDialogClose = () => {
    setWordLimitDialogOpen(false);
    setWordLimitExceeded(false);
  };

  const handleUnique = async () => {
    setLoading(true);
    let payload = {
      text: selectedSentence,
    };
    let uniqueSentenceResponse = await getUniqueSentence(payload);
    let newSentence = uniqueSentenceResponse.data.output[0];
    let currentContent = editorState.getCurrentContent().getPlainText();

    let startIndex = currentContent.indexOf(selectedSentence);
    if (startIndex === -1) {
      console.error("Selected sentence not found in the current content");
      setLoading(false);
      return;
    }
    let endIndex = startIndex + selectedSentence.length;

    const selectionState = SelectionState.createEmpty(
      editorState.getSelection().getAnchorKey(),
    ).merge({
      anchorOffset: startIndex,
      focusOffset: endIndex,
    });

    let newContentState = Modifier.replaceText(
      editorState.getCurrentContent(),
      selectionState,
      newSentence,
    );
    let newEditorState = EditorState.push(
      editorState,
      newContentState,
      "replace-text",
    );

    // Update the editor state with the new unique text
    setEditorState(newEditorState);

    // Calculate stats for the updated text
    const updatedText = newEditorState.getCurrentContent().getPlainText();
    calculateTextStats(updatedText);

    setLoading(false);

    // Check plagiarism for the updated text
    checkPlagiarismSentence(newEditorState.getCurrentContent().getPlainText());
    setIsUniqueButton(false);
  };

  const handleKeyCommand = (command, editorState) => {
    const newState = RichUtils.handleKeyCommand(editorState, command);
    if (newState) {
      handleChange(newState);
      return "handled";
    }
    return "not-handled";
  };

  useEffect(() => {
    const newEditorState = highlightText(editorState, outputArray);
    setEditorState(newEditorState);
  }, [outputArray]);

  const handleDelete = () => {
    setEditorState(EditorState.createEmpty());
    setIsUniqueButton(false);
    setSourceCount(0);

    // Reset plagiarism states
    resetPlagiarismStates();

    // Reset text statistics
    calculateTextStats("");
  };

  const handleDownload = () => {
    if (!editorState.getCurrentContent().getPlainText()) {
      toast.warn(`You don't have text, to download`);
      return;
    }
    const blob = new Blob([editorState.getCurrentContent().getPlainText()], {
      type: "text/plain",
    });

    const anchor = document.createElement("a");
    anchor.href = URL.createObjectURL(blob);
    anchor.download = "text_content.doc";
    anchor.click();
    URL.revokeObjectURL(anchor.href);
  };

  const handleScanDownload = (content) => {
    if (!content) {
      toast.warn(`No content available for download`);
      return;
    }

    const blob = new Blob([content], { type: "text/plain" });
    const anchor = document.createElement("a");
    anchor.href = URL.createObjectURL(blob);
    anchor.download = "text_content.doc";
    anchor.click();
    URL.revokeObjectURL(anchor.href);
  };

  const handlecopy = () => {
    let sentence = editorState.getCurrentContent().getPlainText();
    if (sentence == "") {
      toast.warn(`You don't have text, to copy`);
      return;
    }
    navigator.clipboard.writeText(sentence).then(
      function () {
        if (sentence) toast.info("Your text Copied!");
      },
      function (err) {},
    );
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        const content = event.target.result;
        const text = content.toString();
        const wordCount = getWordCount(text);
        
        if (wordCount > maxWords) {
          toast.warn("Words limit exceeded");
          return;
        }
        
        setWordsCount(wordCount);
        const contentState = ContentState.createFromText(text);
        const newEditorState = EditorState.createWithContent(contentState);
        setEditorState(EditorState.createEmpty());
        setInputKey((prevKey) => prevKey + 1);
        setEditorState(newEditorState);

        // Reset plagiarism states when uploading new file
        resetPlagiarismStates();

        // Calculate statistics for uploaded file
        calculateTextStats(text);
      };
      reader.readAsText(file);
    }
  };

  const addScanHistory = async (countStats, speaktime) => {
    let inputText;
    const selection = editorState.getSelection();
    inputText = editorState
      .getCurrentContent()
      .getBlockForKey(selection.getAnchorKey())
      .getText()
      .slice(selection.getStartOffset(), selection.getEndOffset());

    if (!inputText) {
      inputText = editorState.getCurrentContent().getPlainText();
    }
    const userId = sessionStorage.getItem("userId");
    let data = {
      content: inputText,
      paraCount: countStats.paragraph,
      sentenceCount: countStats.sentence,
      uniqueWordCount: countStats.uniqueWords,
      userId: userId,
      timeDisplay: speaktime,
    };
    let response = await ScanPlagarismservice.addScanHistory(data);
    fetchData();
  };

  const deleteHistory = async (params) => {
    const response = await ScanPlagarismservice.deleteHistory(params);
    fetchData();
    toast.error("Scan history deleted.");
  };

  const fetchData = async () => {
    try {
      const userId = sessionStorage.getItem("userId");
      let data = { userId };
      const response = await ScanPlagarismservice.getScanHistory(data);
      const responsedata = response?.data;
      if (response) {
        setScanHistory(responsedata);
      }
    } catch (error) {
      console.error("Error fetching scan history:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleBreadcrumbClick = (event, path) => {
    event.preventDefault();
    window.location.href = "/docTags";
    // history.push(path);
  };

  const handleStatusClick = async (params) => {
    // const checkailimit = await checkAIRequestLimit(userID);
    // if (checkailimit == false) {
    //   toast.warn("AI request limit reached.");
    //   return;
    // }
    const response = await ScanPlagarismservice.getScanData(params);
    const responseData = response?.data?.content;
    if (response) {
      const contentState = ContentState.createFromText(responseData);
      const newEditorState = EditorState.createWithContent(contentState);
      setEditorState(newEditorState);

      // Reset plagiarism states before loading new scan data
      resetPlagiarismStates();

      // Calculate statistics for loaded scan data
      calculateTextStats(responseData);
      checkPlagiarismSentence(
        newEditorState.getCurrentContent().getPlainText(),
        true,
      );
      const wordCount = getWordCount(responseData);
      setWordsCount(wordCount);
      setHistoryDialogOpen(false);
    }
  };

  const handleScanHistory = () => {
    if (accessToScanHistory == false) {
      setSubReqOpen(true);
      setIsFeatureInside(true);
      return;
    }
    setHistoryDialogOpen(true);
  };

  const columns = [
    {
      field: "name",
      headerName: "Name",
      type: "text",
      flex: 0.2,
      width: !windowWidth ? 240 : 180,
    },
    {
      field: "createdDate",
      headerName: "Date",
      flex: 0.2,
      width: !windowWidth ? 240 : 180,
      valueGetter: (params) => {
        const dateTime = new Date(params.row.createdDate);
        return dateTime.toLocaleDateString();
      },
    },
    {
      field: "createdTime",
      headerName: "Time",
      flex: 0.1,
      width: !windowWidth ? 240 : 180,
      valueGetter: (params) => {
        const dateTime = new Date(params.row.createdTime);
        return dateTime.toLocaleTimeString();
      },
    },
    {
      field: "status",
      headerName: "Status",
      flex: 0.1,
      width: !windowWidth ? 240 : 180,
      renderCell: (params) => (
        <button
          style={{
            backgroundColor: accessToPlagiarism ? "#1976D2" : "black",
            color: accessToPlagiarism ? "white" : "black",
            border: "none",
            borderRadius: "15px",
            padding: "5px 10px",
            cursor: accessToPlagiarism ? "pointer" : "",
            textAlign: "center",
          }}
          onClick={() => handleStatusClick(params.row._id)}
          disabled={!accessToPlagiarism}
        >
          {params.value}
        </button>
      ),
    },
    {
      field: "paragraphs",
      headerName: "Paragraphs",
      flex: 0.1,
      width: !windowWidth ? 240 : 180,
    },
    {
      field: "Score",
      headerName: "Score",
      flex: 0.1,
      width: !windowWidth ? 240 : 180,
    },
    {
      field: "",
      headerName: "",
      width: !windowWidth ? 240 : 180,
      renderCell: (params) => {
        return (
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div
              onClick={() =>
                accessToDelete && handleDeleteClick(params.row._id)
              }
            >
              <Tooltip title="Delete">
                <IconButton size="small">
                  <Delete
                    style={{
                      color: accessToDelete ? "red" : "black",
                      cursor: accessToDelete ? "pointer" : "",
                    }}
                  />
                </IconButton>
              </Tooltip>
            </div>
            <div onClick={() => handleScanDownload(params.row.content)}>
              <Tooltip title="Download">
                <IconButton size="small">
                  <DownloadIcon style={{ color: "green" }} />
                </IconButton>
              </Tooltip>
            </div>
          </div>
        );
      },
    },
  ];

  const loginUserId = sessionStorage.getItem("userId");
  const checkUser = scanHistory?.some(
    (historyItem) => historyItem.userId == loginUserId,
  );

  // Determine if word limit is exceeded
  const isWordLimitExceeded = wordsCount > maxWords;

  return (
    <>
      <SubscriptionRequired
        open={subReqOpen}
        setOpen={setSubReqOpen}
        isFeatureInside={isFeatureInside}
        setIsFeatureInside={setIsFeatureInside}
        path={"plagiarism"}
      />

      {/* Word Limit Warning Dialog - with high z-index */}
      <Dialog
        open={wordLimitDialogOpen}
        onClose={handleWordLimitDialogClose}
        aria-labelledby="word-limit-dialog-title"
        aria-describedby="word-limit-dialog-description"
        sx={{
          zIndex: 100000,
          '& .MuiDialog-container': {
            zIndex: 100000,
          },
          '& .MuiDialog-paper': {
            zIndex: 100001,
            borderRadius: 3,
            padding: 2,
            minWidth: 400,
          }
        }}
      >
        <DialogTitle 
          id="word-limit-dialog-title"
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            color: '#ef4444',
            fontWeight: 600
          }}
        >
          <WarningIcon sx={{ fontSize: 28 }} />
          Word Limit Exceeded
        </DialogTitle>
        <DialogContent>
          <DialogContentText 
            id="word-limit-dialog-description"
            sx={{
              color: '#4b5563',
              fontSize: '1rem'
            }}
          >
            You have entered <strong>{wordsCount}</strong> words, which exceeds the maximum limit of <strong>1500 words</strong>.
          </DialogContentText>
          <Box sx={{ mt: 2, p: 2, bgcolor: '#f3f4f6', borderRadius: 2 }}>
            <Typography variant="body2" sx={{ color: '#1f2937' }}>
              Please reduce your text to 1500 words or less to continue with plagiarism checking.
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 2, pt: 0 }}>
          <Button 
            onClick={handleWordLimitDialogClose}
            variant="contained"
            sx={{
              bgcolor: '#ef4444',
              '&:hover': {
                bgcolor: '#dc2626'
              },
              borderRadius: 2,
              px: 4
            }}
          >
            OK, Got it
          </Button>
        </DialogActions>
      </Dialog>

      {/* ToastContainer with high z-index */}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        style={{ zIndex: 99999 }}
        containerStyle={{ zIndex: 99999 }}
      />

      {/* CSS for high z-index elements */}
      <style>
        {`
          .swal2-container {
            z-index: 100000 !important;
          }
          .swal2-popup {
            z-index: 100001 !important;
          }
        `}
      </style>
      
      <Box
        sx={{
          position: "fixed",
          inset: 0,
          zIndex: 9998,
          overflowY: "auto",
          overflowX: "hidden",
          p: { xs: 1, md: 3 },
          bgcolor: "#f5f7fa",
        }}
      >
        <Loader loading={loading} />
        {/* Modern Breadcrumb Navigation */}
        <Box sx={{ mb: 3 }}>
          <Paper
            elevation={1}
            sx={{
              p: 2.5,
              bgcolor: "white",
              borderRadius: 3,
              border: "1px solid",
              borderColor: "divider",
              transition: "all 0.3s ease",
              "&:hover": {
                boxShadow: "0 4px 12px rgba(102, 126, 234, 0.15)",
              },
            }}
          >
            <Breadcrumbs
              separator={
                <NavigateNextIcon fontSize="small" sx={{ color: "#667eea" }} />
              }
              aria-label="breadcrumb"
              sx={{
                display: "flex",
                alignItems: "center",
                flexWrap: "nowrap",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  flexWrap: "nowrap",
                  gap: 1,
                }}
              >
                <AutoFixHigh sx={{ fontSize: 20, color: "#667eea" }} />
                <Link
                  to="/docTags"
                  onClick={(e) => handleBreadcrumbClick(e, "/docTags")}
                  style={{
                    textDecoration: "none",
                    color: "#667eea",
                    fontWeight: 500,
                    fontSize: "0.95rem",
                    padding: "4px 8px",
                    borderRadius: "6px",
                    transition: "all 0.2s ease",
                    whiteSpace: "nowrap",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor =
                      "rgba(102, 126, 234, 0.08)";
                    e.currentTarget.style.color = "#764ba2";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "transparent";
                    e.currentTarget.style.color = "#667eea";
                  }}
                >
                  MultiTool AI
                </Link>
                <NavigateNextIcon
                  fontSize="small"
                  sx={{ color: "#667eea", mx: 0.5 }}
                />
                <Typography
                  sx={{
                    color: "#1a1a1a",
                    fontWeight: 600,
                    fontSize: "0.95rem",
                    padding: "4px 8px",
                    borderRadius: "6px",
                    backgroundColor: "rgba(102, 126, 234, 0.08)",
                    whiteSpace: "nowrap",
                    display: "flex",
                    alignItems: "center",
                    gap: 0.5,
                  }}
                >
                  <AutoFixHigh sx={{ fontSize: 20, color: "#667eea" }} />
                  Plagiarism Checker
                </Typography>
              </Box>
            </Breadcrumbs>
          </Paper>
        </Box>

        <Grid container spacing={3}>
          {/* Header Section */}
          <Grid xs={12}>
            <Paper
              elevation={0}
              sx={{
                p: 1,
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                color: "white",
                borderRadius: 3,
              }}
            >
              <Grid container>
                <Grid xs={12} lg={6} md={6} p={1}>
                  <Typography variant="h4" fontWeight="bold" gutterBottom>
                    <AutoFixHigh sx={{ fontSize: 36, color: "white" }} />
                    Plagiarism Checker
                  </Typography>
                  <Typography variant="body1" sx={{ opacity: 0.9 }}>
                    Check your content for originality and uniqueness
                  </Typography>
                </Grid>
                <Grid xs={12} lg={6} md={6}>
                  <Card elevation={3} sx={{ borderRadius: 3, height: "100px" }}>
                    <CardContent>
                      <Grid container spacing={2}>
                        <Grid xs={6} sm={3}>
                          <Paper
                            elevation={0}
                            sx={{
                              bgcolor: "#e3f2fd",
                              textAlign: "center",
                              minWidth: "100px",
                              minHeight: "70px",
                              p: 1,
                            }}
                          >
                            <Grid container spacing={2}>
                              <Grid xs={6} lg={4} md={4} paddingTop={1.5}>
                                <ArticleIcon
                                  color="primary"
                                  sx={{ fontSize: 44 }}
                                />
                              </Grid>
                              <Grid xs={6} lg={8} md={8}>
                                <Typography
                                  variant="h5"
                                  fontWeight="bold"
                                  color="primary"
                                >
                                  {paraCount}
                                </Typography>
                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                >
                                  Paragraphs
                                </Typography>
                              </Grid>
                            </Grid>
                          </Paper>
                        </Grid>
                        <Grid xs={6} sm={3}>
                          <Paper
                            elevation={0}
                            sx={{
                              bgcolor: "#f3e5f5",
                              textAlign: "center",
                              minWidth: "100px",
                              minHeight: "70px",
                              p: 1,
                            }}
                          >
                            <Grid container spacing={2}>
                              <Grid xs={6} lg={4} md={4} paddingTop={1.5}>
                                <FormatQuoteIcon
                                  color="secondary"
                                  sx={{ fontSize: 44 }}
                                />
                              </Grid>
                              <Grid xs={6} lg={8} md={8}>
                                <Typography
                                  variant="h5"
                                  fontWeight="bold"
                                  color="secondary"
                                >
                                  {sentenceCount}
                                </Typography>
                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                >
                                  Sentences
                                </Typography>
                              </Grid>
                            </Grid>
                          </Paper>
                        </Grid>
                        <Grid xs={6} sm={3}>
                          <Paper
                            elevation={0}
                            sx={{
                              p: 1,
                              bgcolor: "#fff3e0",
                              textAlign: "center",
                              minWidth: "120px",
                              minHeight: "70px",
                            }}
                          >
                            <Grid container spacing={2}>
                              <Grid xs={6} lg={4} md={4} paddingTop={1.5}>
                                <SpellcheckIcon
                                  sx={{ color: "#ff9800", fontSize: 44 }}
                                />
                              </Grid>
                              <Grid xs={6} lg={8} md={8}>
                                <Typography
                                  variant="h5"
                                  fontWeight="bold"
                                  sx={{ color: "#ff9800" }}
                                >
                                  {uniqueWordCount}
                                </Typography>
                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                >
                                  Unique Words
                                </Typography>
                              </Grid>
                            </Grid>
                          </Paper>
                        </Grid>
                        <Grid
                          xs={6}
                          sm={3}
                          alignSelf={"center"}
                          textAlign={"center"}
                        >
                          <Paper
                            elevation={0}
                            sx={{
                              p: 1,
                              bgcolor: "#e8f5e9",
                              textAlign: "center",
                              minWidth: "120px",
                              minHeight: "70px",
                            }}
                          >
                            <Grid container spacing={2}>
                              <Grid xs={6} lg={4} md={4} paddingTop={1.5}>
                                <TimerIcon
                                  sx={{ color: "#4caf50", fontSize: 44 }}
                                />
                              </Grid>
                              <Grid xs={6} lg={8} md={8}>
                                <Typography
                                  variant="h5"
                                  fontWeight="bold"
                                  sx={{ color: "#4caf50" }}
                                >
                                  {timeDisplay}
                                </Typography>
                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                >
                                  Read Time
                                </Typography>
                              </Grid>
                            </Grid>
                          </Paper>
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            </Paper>
          </Grid>

          {/* Main Content Area */}
          <Grid container xs={12} lg={12}>
            <Grid xs={12} lg={8}>
              <Card elevation={3} sx={{ borderRadius: 3 }}>
                <CardContent>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      mb: 2,
                      flexWrap: "wrap",
                      gap: 1,
                    }}
                  >
                    <Typography variant="h6" fontWeight="bold" color="primary">
                      Text Editor
                    </Typography>
                    <Chip
                      label={`${wordsCount} / ${maxWords} words`}
                      color={isWordLimitExceeded ? "error" : "primary"}
                      variant="outlined"
                      sx={{
                        bgcolor: isWordLimitExceeded ? "#ef4444" : "inherit",
                        color: isWordLimitExceeded ? "white" : "inherit",
                        borderColor: isWordLimitExceeded ? "#ef4444" : "currentColor",
                        '& .MuiChip-label': {
                          color: isWordLimitExceeded ? "white" : "inherit",
                        }
                      }}
                    />
                  </Box>

                  <Paper
                    elevation={0}
                    sx={{
                      p: 2,
                      minHeight: "450px",
                      maxHeight: "450px",
                      overflow: "scroll",
                      bgcolor: "#fafafa",
                      border: "2px solid #e0e0e0",
                      borderRadius: 2,
                      "&:hover": {
                        borderColor: "#1976d2",
                      },
                    }}
                  >
                    <Editor
                      editorState={editorState}
                      placeholder="Paste or type your text here to check for plagiarism..."
                      onChange={handleChange}
                      handleKeyCommand={handleKeyCommand}
                    />
                  </Paper>

                  {/* Action Buttons */}
                  <Box
                    sx={{
                      display: "flex",
                      gap: 1,
                      mt: 2,
                      flexWrap: "wrap",
                      justifyContent: "space-between",
                    }}
                  >
                    <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
                      <Tooltip title="Copy Text">
                        <IconButton
                          onClick={handlecopy}
                          sx={{
                            bgcolor: "#e3f2fd",
                            "&:hover": { bgcolor: "#bbdefb" },
                          }}
                        >
                          <ContentCopyIcon color="primary" />
                        </IconButton>
                      </Tooltip>

                      <Tooltip title="Download">
                        <IconButton
                          onClick={handleDownload}
                          sx={{
                            bgcolor: "#e8f5e9",
                            "&:hover": { bgcolor: "#c8e6c9" },
                          }}
                        >
                          <DownloadIcon sx={{ color: "#4caf50" }} />
                        </IconButton>
                      </Tooltip>

                      <Tooltip title="Clear Text">
                        <IconButton
                          onClick={handleDelete}
                          sx={{
                            bgcolor: "#ffebee",
                            "&:hover": { bgcolor: "#ffcdd2" },
                          }}
                        >
                          <Delete color="error" />
                        </IconButton>
                      </Tooltip>

                      <Button
                        disabled={!accessToUpload}
                        component="label"
                        variant="outlined"
                        startIcon={<CloudUploadIcon />}
                        sx={{ borderRadius: 2 }}
                      >
                        Upload File
                        <input
                          key={inputKey}
                          type="file"
                          accept=".txt"
                          style={{ display: "none" }}
                          onChange={handleFileChange}
                        />
                      </Button>

                      <Button
                        variant="contained"
                        startIcon={<HistoryIcon />}
                        onClick={handleScanHistory}
                        sx={{
                          borderRadius: 2,
                          background:
                            "linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)",
                        }}
                      >
                        Scan History
                      </Button>
                    </Box>

                    <Box sx={{ display: "flex", gap: 1 }}>
                      {!isUniqueButton ? (
                        <Button
                          disabled={!accessToPlagiarism || wordsCount === 0}
                          variant="contained"
                          onClick={handleCheckPlagiarism}
                          size="large"
                          sx={{
                            borderRadius: 2,
                            px: 4,
                            background: isWordLimitExceeded 
                              ? "#ef4444"
                              : "linear-gradient(45deg, #667eea 30%, #764ba2 90%)",
                            boxShadow: isWordLimitExceeded 
                              ? "0 3px 5px 2px rgba(239, 68, 68, .3)"
                              : "0 3px 5px 2px rgba(102, 126, 234, .3)",
                            '&:hover': {
                              background: isWordLimitExceeded 
                                ? "#dc2626"
                                : "linear-gradient(45deg, #764ba2 30%, #667eea 90%)",
                            },
                            opacity: wordsCount === 0 ? 0.5 : 1,
                          }}
                        >
                          Check Plagiarism
                        </Button>
                      ) : (
                        <Button
                          variant="contained"
                          onClick={handleUnique}
                          size="large"
                          sx={{
                            borderRadius: 2,
                            px: 4,
                            background:
                              "linear-gradient(45deg, #56ab2f 30%, #a8e063 90%)",
                            boxShadow: "0 3px 5px 2px rgba(86, 171, 47, .3)",
                          }}
                        >
                          Make it Unique
                        </Button>
                      )}
                    </Box>
                  </Box>
                </CardContent>
              </Card>
            </Grid>

            <Grid container spacing={1} xs={12} lg={4}>
              {/* Statistics Cards */}
              <Grid xs={12} md={6}>
                <Grow in timeout={500}>
                  <Card
                    elevation={3}
                    sx={{
                      borderRadius: 3,
                      background: "white",
                      color: "red",
                    }}
                  >
                    <CardContent sx={{ textAlign: "center", py: 1 }}>
                      <WarningAmberIcon sx={{ fontSize: 18, mb: 1 }} />
                      <Box
                        sx={{
                          width: 120,
                          height: 80,
                          margin: "0 auto",
                          mb: 1,
                        }}
                      >
                        <CircularProgressbar
                          value={plagiarozedProgress}
                          text={`${plagiarozedProgress}%`}
                          counterClockwise={true}
                          circleRatio={0.6}
                          styles={buildStyles({
                            rotation: 0.3,
                            strokeLinecap: "butt",
                            pathColor:
                              plagiarozedProgress > 0 ? "red" : "#e0e0e0",
                            trailColor: "rgba(255, 126, 126, 0.1)",
                            textColor: plagiarozedProgress > 0 ? "red" : "#666",
                            textSize: "18px",
                          })}
                        />
                      </Box>
                      <Typography variant="h6" fontWeight="bold">
                        Plagiarized Content
                      </Typography>
                    </CardContent>
                  </Card>
                </Grow>
              </Grid>
              <Grid xs={12} md={6}>
                <Grow in timeout={700}>
                  <Card
                    elevation={3}
                    sx={{
                      borderRadius: 3,
                      background: "white",
                      color: "#56ab2f",
                    }}
                  >
                    <CardContent sx={{ textAlign: "center", py: 1 }}>
                      <CheckCircleOutlineIcon sx={{ fontSize: 18, mb: 1 }} />
                      <Box
                        sx={{
                          width: 120,
                          height: 80,
                          margin: "0 auto",
                          mb: 1,
                        }}
                      >
                        <CircularProgressbar
                          value={uniqueProgress}
                          text={`${uniqueProgress}%`}
                          circleRatio={0.6}
                          styles={buildStyles({
                            rotation: 0.7,
                            strokeLinecap: "butt",
                            pathColor:
                              uniqueProgress > 0 ? "#56ab2f" : "#e0e0e0",
                            trailColor: "rgba(129, 241, 119, 0.1)",
                            textColor: uniqueProgress > 0 ? "#56ab2f" : "#666",
                            textSize: "18px",
                          })}
                        />
                      </Box>
                      <Typography variant="h6" fontWeight="bold">
                        Unique Content
                      </Typography>
                    </CardContent>
                  </Card>
                </Grow>
              </Grid>
              <Grid xs={12} lg={12}>
                <Fade in timeout={800}>
                  <Box>
                    <SuggestionCard
                      sentenceArray={outputArray}
                      sourceCount={sourceCount}
                    />
                  </Box>
                </Fade>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {/* Scan History Dialog */}
        <Dialog
          open={historyDialogOpen}
          onClose={() => setHistoryDialogOpen(false)}
          maxWidth="lg"
          fullWidth
          PaperProps={{
            sx: {
              borderRadius: 3,
              minHeight: "70vh",
            },
          }}
        >
          <DialogTitle
            sx={{
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              color: "white",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <HistoryIcon />
              <Typography variant="h6" fontWeight="bold">
                Scan History
              </Typography>
            </Box>
            <IconButton
              onClick={() => setHistoryDialogOpen(false)}
              sx={{ color: "white" }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent sx={{ mt: 2 }}>
            {checkUser ? (
              <Box sx={{ width: "100%", mt: 2 }}>
                <DataGridMui
                  height="50vh"
                  getRowId={(data) => data._id}
                  columns={columns}
                  rows={scanHistory}
                  checkboxSelection={false}
                  bgWhite={true}
                  width="100%"
                />
              </Box>
            ) : (
              <Box
                sx={{
                  textAlign: "center",
                  py: 8,
                }}
              >
                <HistoryIcon sx={{ fontSize: 80, color: "#ccc", mb: 2 }} />
                <Typography variant="h6" color="text.secondary">
                  No scan history found
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ mt: 1 }}
                >
                  Start checking your content for plagiarism to see results here
                </Typography>
              </Box>
            )}
          </DialogContent>
          <DialogActions sx={{ p: 2, bgcolor: "#f5f5f5" }}>
            <Button
              onClick={() => setHistoryDialogOpen(false)}
              variant="contained"
              sx={{ borderRadius: 2 }}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    </>
  );
};

export default Plagiarism_1;